"use client"

import { useCallback } from "react"
import { useSearchParams } from "next/navigation"
import { useDocumentEditorStore } from "@/stores/use-document-editor-store"

import { useLoadingRouter } from "@/hooks/use-loading-router"
import { useArtifactEditDialog } from "@/components/dialogs/artifact-edit-dialog"
import { DocumentChatPanel } from "@/components/document-editor/document-chat-panel"
import { DocumentPreviewFrame } from "@/components/document-editor/document-preview-frame"

export const DOCUMENT_EDITOR_DIALOG_PARAM = "document-editor"

interface OpenDocumentEditorOptions {
  deliverableId: string
  actionLinkId: string
  title: string
}

export function useDocumentEditorDialog() {
  const openArtifactEditDialog = useArtifactEditDialog()
  const searchParams = useSearchParams()
  const { replace } = useLoadingRouter()

  return useCallback(
    ({ deliverableId, actionLinkId, title }: OpenDocumentEditorOptions) => {
      openArtifactEditDialog({
        title,
        chat: <DocumentChatPanel deliverableId={deliverableId} />,
        preview: <DocumentPreviewFrame deliverableId={deliverableId} actionLinkId={actionLinkId} />,
        closeCallback: () => {
          useDocumentEditorStore.getState().reset()
          const params = new URLSearchParams(searchParams.toString())
          params.delete("dialog")
          params.delete("id")
          replace(`?${params.toString()}`)
        },
      })

      const params = new URLSearchParams(searchParams.toString())
      params.set("dialog", DOCUMENT_EDITOR_DIALOG_PARAM)
      params.set("id", actionLinkId)
      replace(`?${params.toString()}`)
    },
    [openArtifactEditDialog, replace, searchParams]
  )
}
